export const searchBarBorderColor = "#CECACA"
export const addButtonColor = "#2A7CED"
export const deleteButtonColor = "#FF4343"
export const textColor = "#707070"
export const mainAccordingColor = "rgb(249, 249, 249)"
export const subAccordingColor = "rgba(124, 142, 150, 0.2)"
